import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_immo-sales/artifacts/fd8qldce_immostaging1%20png.png";

const navLinks = [
  { href: "/", label: "Accueil" },
  { href: "/ventes", label: "Nos Biens" },
  { href: "/honoraires", label: "Honoraires" },
  { href: "/contact", label: "Contact" },
];

export default function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="sticky top-0 z-50 glass-nav" data-testid="navigation">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-testid="nav-logo">
            <img 
              src={LOGO_URL} 
              alt="IMMOSTAGING" 
              className="h-16 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium transition-colors hover:text-[#D62965] ${
                  location.pathname === link.href
                    ? "text-[#D62965] border-b-2 border-[#D62965] pb-1"
                    : "text-zinc-700"
                }`}
                data-testid={`nav-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Phone CTA */}
          <div className="hidden md:flex items-center">
            <a 
              href="tel:0612072367" 
              className="flex items-center gap-2 text-[#00B5AD] hover:text-[#008B85] font-medium"
              data-testid="nav-phone"
            >
              <Phone className="h-4 w-4" />
              <span>06 12 07 23 67</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setIsOpen(!isOpen)}
              data-testid="mobile-menu-toggle"
            >
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </Button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden py-4 border-t border-zinc-200" data-testid="mobile-menu">
            <div className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`text-base font-medium px-4 py-2 rounded transition-colors ${
                    location.pathname === link.href
                      ? "text-[#D62965] bg-[#D62965]/10"
                      : "text-zinc-700 hover:text-[#D62965] hover:bg-zinc-50"
                  }`}
                  onClick={() => setIsOpen(false)}
                  data-testid={`mobile-nav-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                >
                  {link.label}
                </Link>
              ))}
              <a 
                href="tel:0612072367" 
                className="flex items-center gap-2 text-[#00B5AD] font-medium px-4 py-2"
                data-testid="mobile-nav-phone"
              >
                <Phone className="h-4 w-4" />
                <span>06 12 07 23 67</span>
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
